"use strict";
/*
 * Created on 01 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var EntityAttributeByEntityData_1 = require("./EntityAttributeByEntityData");
/**
 * Aggregation of {@link EntityAttribute entity attribute }over {@link EntityAttribute.entityId}.
 *
 * @author JMe
 */


var EntityAttributeByEntity =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityAttributeByEntity, _DomainObject_1$Domai);

  /**
   * @param entityId internal id of an entity
   * @param dataPerEntity list of all remaining data per this entity
   */
  function EntityAttributeByEntity(entityId, dataPerEntity) {
    var _this;

    _classCallCheck(this, EntityAttributeByEntity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeByEntity).call(this));
    _this.entityId = entityId;
    _this.dataPerEntity = dataPerEntity;
    return _this;
  }
  /**
   * @param clazzId filtered clazzId
   * @param day day to which attributes should be tested
   * @param attributeId the filtered attribute id
   * @returns list of data per entity that satisfy given filter
   */


  _createClass(EntityAttributeByEntity, [{
    key: "getDataPerEntity",
    value: function getDataPerEntity(clazzId, day, attributeId) {
      if (this.dataPerEntity.size === 0) {
        return immutable_1.List();
      }

      return this.dataPerEntity.filter(function (v) {
        if (v.clazzId !== clazzId) {
          return false;
        }

        if (!utils_1.Utils.isValueMissing(attributeId) && v.attributeId !== attributeId) {
          return false;
        }

        if (!utils_1.Utils.isValueMissing(day) && (day.isBefore(v.validFrom) || day.isAfter(v.validTo))) {
          return false;
        }

        return true;
      });
    }
  }]);

  return EntityAttributeByEntity;
}(DomainObject_1.DomainObject);

exports.EntityAttributeByEntity = EntityAttributeByEntity;

EntityAttributeByEntity.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(EntityAttributeByEntity.name);
  return {
    entityId: builder.id('entityId'),
    dataPerEntity: builder.listOf(builder.obj('dataPerEntity', EntityAttributeByEntityData_1.EntityAttributeByEntityData.schema, function (mat) {
      return EntityAttributeByEntityData_1.EntityAttributeByEntityData.fromDataDict(mat);
    }))
  };
}();